export class BreakpointConstants {
  static mobileBreakpoint = 480;
  static tabletBreakpoint = 768;
  static desktopBreakpoint = 1280;
}
